__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-07-10-1783674907-stable-dev/";